function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "capa_fb",
  "data-name": "capa_fb"
}, React.createElement("g", {
  id: "capa_fb-2",
  "data-name": "capa fb 1"
}, React.createElement("g", {
  id: "Facebook_Circle",
  "data-name": "Facebook Circle"
}, React.createElement("path", {
  className: "cls-fb",
  d: "M26.53,0A26.53,26.53,0,1,0,53.05,26.53,26.53,26.53,0,0,0,26.53,0Zm0,50.64A24.12,24.12,0,1,1,50.64,26.53,24.11,24.11,0,0,1,26.53,50.64ZM28.92,20.8c0-1,.1-1.5,1.61-1.5h2V15.67H29.32c-3.85,0-5.21,1.82-5.21,4.87V22.9h-2.4v3.63h2.4V37.38h4.81V26.53h3.21l.42-3.63H28.92Z"
}))));

var SvgCellfinateIconoFacebook = function SvgCellfinateIconoFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 53.05 53.05",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCellfinateIconoFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cellfinate_icono_facebook.80aa5b0a.svg";
export { ForwardRef as ReactComponent };